import { motion } from "framer-motion";
import { Star } from "lucide-react";

const reviews = [
  {
    text: "Took some furniture for me. Was quick and easy, as well as affordable!",
    name: "Abi",
  },
  {
    text: "Great experience from start to finish! The team was professional, friendly, and got everything removed quickly. They were on time, efficient, and made the whole process easy. Highly recommend!",
    name: "Gabriel",
  },
  {
    text: "Just had recently moved out of our home needed loads of stuff taken out I called these 2 young guys and they got me booked in same week and got the job done in 1 day super easy to work with highly recommend!",
    name: "Prestige Mobile Auto Detailing",
  },
];

export default function Reviews() {
  return (
    <section className="grain relative bg-navy px-5 py-20 sm:px-10 lg:py-28 xl:px-16" data-testid="reviews-section">
      <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="mb-3 font-mono2 text-[11px] uppercase tracking-[0.35em] text-royal">Reviews</p>
          <h2 className="font-display text-5xl uppercase leading-none text-white sm:text-7xl">
            Five stars,<br />in their words.
          </h2>
        </div>
        <span className="flex gap-1" aria-label="Five star rating">
          {[0, 1, 2, 3, 4].map((s) => (
            <Star key={s} className="h-6 w-6 fill-[#FBBC04] text-[#FBBC04] sm:h-8 sm:w-8" strokeWidth={1.5} />
          ))}
        </span>
      </div>
      <div className="grid grid-cols-1 gap-px bg-white/15 md:grid-cols-3">
        {reviews.map((r, i) => (
          <motion.blockquote
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col justify-between bg-navy p-8 transition-colors duration-200 hover:bg-royal lg:p-10"
            data-testid={`review-card-${i + 1}`}
          >
            <div>
              <span className="font-display text-6xl leading-none text-royal transition-colors duration-200">&ldquo;</span>
              <p className="mt-2 text-base leading-relaxed text-white/85 md:text-lg">{r.text}</p>
            </div>
            <footer className="mt-8 border-t border-white/15 pt-4">
              <div className="flex items-center justify-between">
                <span className="flex gap-0.5">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-[#FBBC04] text-[#FBBC04]" strokeWidth={1.5} />
                  ))}
                </span>
                <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-white/50">
                  Google review
                </span>
              </div>
              <p className="mt-3 font-display text-lg uppercase tracking-wide text-white" data-testid={`review-name-${i + 1}`}>
                {r.name}
              </p>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </section>
  );
}
